
<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<div style="min-height: 500px;">

    
    <main id="content" role="main" class="main">
        <!-- Content -->
        <div class="content container">
            <div >
                <nav aria-label="breadcrumb">
                    <ol id="w2" class="breadcrumb">
                        <li class="breadcrumb-item">الرئيسية</li>
                        <li class="breadcrumb-item active" aria-current="page">تقرير الايرادات </li>
                    </ol>
                </nav>
            </div>
            <div class="receipt-index" >
    
    
                <div class="receipt-search">
    
                    <h4>بحث </h4>
                    <div class="row">
                        <div class="col-4">
                            <p>من تاريخ</p>
                            <input type="date" class="form-control" [(ngModel)]="fromDate" name="fromDate">
                        </div>
                        <div class="col-4">
                            <p>الى تاريخ</p>
                            <input type="date" class="form-control" [(ngModel)]="toDate" name="toDate">
                        </div>
                    </div>
    
                    <div class="form-group mt-3">
                        <button (click)="getData()" [disabled]="fromDate==undefined||toDate==undefined" class="btn btn-primary">
                            احتساب                        
                        </button>
                    </div>
    
                </div>
    
                <br>
                <br>
                <br>
                <br>
    
                <div class="row" *ngFor="let item of reportList">
                    <div class="col-8">
                        <P>
                            اسم الخدمة : {{item.serviceName}}
                        </P>
                    </div>
    
                    <div class="col-4">
                        <P>
                            المجموع : {{item.total}}
                        </P>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Content -->
    </main>
    
    </div>